export class FileUpload {

  id: string;

  idObject: string;

  idSubObject: string;

  fileBytes:any

  file: string;

  title: string;

  token: string;

  url: string;

  photoBytes: any;

  x: number ;

  y: number;

  width: number;

  height: number;

  rotate: number;

  finalWidth: number;

  index: number;
}
